import apiCall from '@/utils/apiCall';

export default {
    /**
     * Updates data.
     *
     * @param  {object} options  Vuex context
     * @param  {object} data     User data.
     */
    updateData({ state, commit }, data) {
        commit('setData', { ...state.data, ...data });
    },

    /**
     * Appends errors.
     *
     * @param  {object} options  Vuex context
     * @param  {object} errors   Errors collection.
     */
    appendErrors({ state, commit }, errors) {
        commit('setErrors', { ...state.errors, ...errors });
    },

    /**
     * Clears error.
     *
     * @param  {object} options  Vuex context
     * @param  {string} errorKey Error key.
     */
    clearError({ state, commit }, errorKey) {
        const errors = { ...state.errors };
        delete errors[errorKey];
        commit('setErrors', errors);
    },

    /**
     * Clears all errors.
     *
     * @param  {object} options  Vuex context
     */
    clearErrors({ commit }) {
        commit('setErrors', {});
    },

    /**
     * Validates data.
     *
     * @param   {object} options  Vuex context
     * @param   {object} data     User data.
     * @returns {boolean} Validation result.
     */
    async validateData({ dispatch, getters }, data) {
        /**
         * Checks whether given key is in data collection.
         *
         * @param   {string} key Key to verify.
         * @returns {boolean} Check result.
         */
        const dataHasKey = (key) => Object.keys(data).includes(key);

        if (dataHasKey('name') && ! data.name) {
            dispatch('appendErrors', { name: 'required' });
        }

        if (dataHasKey('email') && ! data.email) {
            dispatch('appendErrors', { email: 'required' });
        }

        if (dataHasKey('consent') && ! data.consent) {
            dispatch('appendErrors', { consent: 'accept' });
        }

        if (
            dataHasKey('password') &&
            dataHasKey('passwordConfirm') &&
            data.password !== data.passwordConfirm
        ) {
            dispatch('appendErrors', { passwordConfirm: 'confirm' });
        }

        if (dataHasKey('password') && ! data.password) {
            dispatch('appendErrors', { password: 'required' });
        }

        if (dataHasKey('passwordConfirm') && ! data.passwordConfirm) {
            dispatch('appendErrors', { passwordConfirm: 'required' });
        }

        return ! getters.hasErrors;
    },

    /**
     * Updates step to the next one.
     *
     * @param  {object} options  Vuex context
     */
    nextStep({ state, commit }) {
        commit('setStep', { step: state.step + 1 });
    },

    /**
     * Updates step to the previous one.
     *
     * @param  {object} options  Vuex context
     */
    previousStep({ state, commit }) {
        commit('setStep', { step: state.step - 1 });
    },

    /**
     * Regsiters user.
     *
     * @param  {object} options  Vuex context.
     * @param  {object} data     Additional data.
     */
    async registerUser({ state }, data = {}) {
        return apiCall(this._vm, 'post', '/api/user/register', {
            ...data,
            name: state.data.name,
            email: state.data.email,
            password: state.data.password,
            password_confirmation: state.data.passwordConfirm,
        });
    },
};
